import type { ForwardRefExoticComponent } from 'react';
import { forwardRef } from 'react';
import type { BaseActionProps } from '../Actions';
import type { CloseButtonContainerProps } from './CloseButtonContainer';
import { CloseButtonContainer } from './CloseButtonContainer';
import { CloseIcon } from './CloseIcon';

export interface CloseActionProps
  extends BaseActionProps,
    CloseButtonContainerProps {
  iconSize?: 'm' | 's';
}

const CloseActionRender = (
  { description, iconSize = 'm', ...props }: CloseActionProps,
  ref,
): JSX.Element => {
  return (
    <CloseButtonContainer ref={ref} {...props}>
      <CloseIcon description={description} size={iconSize} />
    </CloseButtonContainer>
  );
};

/**
 * CloseAction component.
 *
 * {@link https://zeroheight.com/76c439891/p/542b55-common-actions/t/28e1d3 Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-closeaction--close-action Code documentation}
 *
 * @example
 * <CloseAction onClick={() => {}} description='Close my component'/>
 */
export const CloseAction = forwardRef<HTMLButtonElement, CloseActionProps>(
  CloseActionRender,
) as ForwardRefExoticComponent<CloseActionProps>;

CloseAction.displayName = 'CloseAction';

CloseAction.defaultProps = {
  isColorInverted: false,
};
